export const MIN_SAMPLE_RATE = 3000;
